import { DeleteOutline as DeleteOutlineIcon, Edit as EditIcon } from '@mui/icons-material';
import { MenuItem } from '@mui/material';
import { AuthContext } from 'providers/authProvider';
import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { hasPermission } from 'services/auth';

import { ConfirmModal, MoreMenu, NOTIFICATION_TYPE, Notification } from 'components';
import { useDeleteExporter } from 'features/sellers/hooks/useDeleteExporter';

const ExporterActionButton = ({ exporter }) => {
  const { user } = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);

  const { mutate: deleteExporter, isLoading } = useDeleteExporter({
    onSuccess: () => {
      setAnchorEl(null);
      Notification(NOTIFICATION_TYPE.SUCCESS, 'Seller is removed successfully.');
    },
    onError: (err) => {
      Notification(NOTIFICATION_TYPE.DANGER, err.message);
    },
  });

  return (
    <>
      <MoreMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
        <MenuItem
          onClick={() => setShowConfirm(true)}
          disabled={!hasPermission(user, { resource: 'seller', action: 'delete' }) || isLoading}
          data-testid="remove-exporter-btn"
        >
          <DeleteOutlineIcon sx={{ mr: '1rem' }} />
          Remove
        </MenuItem>
        <MenuItem disabled={!hasPermission(user, { resource: 'seller', action: 'update' })}>
          <Link to={`edit/${exporter.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
            <EditIcon sx={{ mr: '1rem' }} />
            Edit
          </Link>
        </MenuItem>
      </MoreMenu>

      <ConfirmModal
        show={showConfirm}
        handleClose={() => setShowConfirm(false)}
        title="Remove Exporter"
        content="Are you sure you want to remove this exporter?"
        onConfirm={() => deleteExporter(exporter.id)}
      />
    </>
  );
};

export default ExporterActionButton;
